import mx from '../mx';

const mxAutoSaveManager = mx.mxAutoSaveManager;

// mxAutoSaveManager.prototype.autoSaveThrottle = 1;
// mxAutoSaveManager.prototype.autoSaveThreshold = 1;
// mxAutoSaveManager.prototype.autoSaveDelay = 1;

export { mxAutoSaveManager };
